<template>
	<div>
		<vxe-modal v-model="modal_model" title="账户余额" :width="modal_width" :height="modal_height" @show="modal_onshow"
			show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		data() {
			return {
				selectTab: 'balance',
				modal: true,
				loading: false,
				modal_width: 1200,
				modal_height: 800
			}
		},
		methods: {
			list_footerMethod({
				data
			}) {
				let footData = [
					['合计', '', '', '', '', (this.$Lodash.sumBy(data, item => parseFloat(item.bal))).toFixed(2)]
				]
				let groupclass = this.$Lodash.groupBy(data, 'class')
				//let groupclasstotal = 0
				for (let i in groupclass) {
					let sum = this.$Lodash.sumBy(groupclass[i], item => parseFloat(item.bal))
					//groupclasstotal += sum
					groupclass[i] = sum.toFixed(2)
				}
				for (let i in groupclass) {
					footData.push([i, '', '', '', '', groupclass[i]])
				}
				//footData.push(['合计','','','','', groupclasstotal.toFixed(2)])


				let groupbankType = this.$Lodash.groupBy(data, 'bankType')
				//let groupbankTypetotal = 0
				for (let i in groupbankType) {
					let sum = this.$Lodash.sumBy(groupbankType[i], item => parseFloat(item.bal))
					//groupbankTypetotal += sum
					groupbankType[i] = sum.toFixed(2)
				}
				for (let i in groupbankType) {
					footData.push([i, '', '', '', '', groupbankType[i]])
				}
				// footData.push(['合计','','','','', groupbankTypetotal.toFixed(2)])			
				// let total = (this.$Lodash.sumBy(data, item => parseFloat(item.bal))).toFixed(2)				
				// let totalfootData = ['合计','','','','',total]
				return footData
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 700
				gridOptions.showFooter = true
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				}]
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width: 100,
					}, {
						field: 'wlncode',
						title: '万里牛编码',
					}, {
						field: 'wlnname',
						title: '万里牛名称',
					}, {
						field: 'bankName',
						title: '开户银行',
					},
					{
						field: 'bankAcc',
						title: '账号'
					},
					{
						field: 'accName',
						title: '账户名称',
					},
					{
						field: 'class',
						title: '资金状态',
					},
					{
						title: '余额',
						align:'center',
						children: [{
								field: 'bal',
								title: '财资',
							},
							{
								field: 'wlnbal',
								title: '万里牛',
							},
							{
								field: 'nazhibal',
								title: '云系统',
							},
						]
					},

					{
						field: 'lastTime',
						title: '更新时间',
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.reconciliation_bankflow.getSummary({
						transTime: this.transTime
					}).then((res) => {
						//inst_account
						res.bankAccList.forEach((item)=>{
							item.wlnbal = null
							let wlnaccount = res.wlnbankAccList.find((_item)=>{
								return _item.inst_account == item.bankAcc
							})
							if(wlnaccount){
								item.wlnname = wlnaccount.acc_name
								item.wlncode = wlnaccount.acc_code
								item.wlnbal = wlnaccount.balance
							}
						})
						resolve({
							list: res.bankAccList
						})
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		}
	}
</script>